import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Request} from "../../../classes/request";
import {HttpErrorResponse} from "@angular/common/http";
import {UserSessionService} from "../../../services/userSession";
import {RequestService} from "../../../services/request";
import {UserSession} from "../../../classes/userSession";
import {RequestTypeService} from "../../../services/requestType";
import {RequestType} from "../../../classes/requestType";
import {CustomerService} from "../../../services/customer";
import {Customer} from "../../../classes/customer";
import {CustomerPick, normalizeCustomerEmails, toCustomerPick} from "../../../utils/customerEmails";
import {ReferrerService} from "../../../services/referrer";
import {Referrer} from "../../../classes/referrer";
import {SupplierService} from "../../../services/supplier";
import {Supplier} from "../../../classes/supplier";
import {PartyOption, partyOptionList, searchParty, splitPartyKeys} from "../../../utils/partyOptions";

@Component({
    selector: 'app-request-create-modal',
    templateUrl: './request-create-modal.component.html',
    styleUrls: ['./request-create-modal.component.css']
})
export class RequestCreateModalComponent implements OnInit {
    request: Request = new Request();
    requestTypes: Array<RequestType> = [];
    requestInvestmentRanges: Array<any> = [];
    selectedInvestmentRangeId: number = 0;
    customerOptions: CustomerPick[] = [];
    selectedCustomerId: number | null = null;
    partyOptions: PartyOption[] = [];
    selectedPartyKeys: string[] = [];
    partyLoadError: string = '';
    private loadedReferrers: Array<Referrer> | null = null;
    private loadedSuppliers: Array<Supplier> | null = null;
    newCustomerEmails: string[] = [''];
    recipientSelection: { [email: string]: boolean } = {};
    formError: string = '';
    saving: boolean = false;

    constructor(public activeModal: NgbActiveModal,
                private userSessionService: UserSessionService,
                private requestService: RequestService,
                private requestTypeService: RequestTypeService,
                private customerService: CustomerService,
                private referrerService: ReferrerService,
                private supplierService: SupplierService) {
    }

    ngOnInit(): void {
        this.request.FKIDRequestType = 1;
        this.onRequestTypeChange();
        this.requestTypeService.getAll()
            .subscribe({
                next: (requestTypeList: any) => {
                    this.requestTypes = requestTypeList;
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });

        this.customerService.getAll()
            .subscribe({
                next: (customers: Array<Customer>) => {
                    this.customerOptions = customers
                        .map(customer => toCustomerPick(customer))
                        .filter((customer): customer is CustomerPick => customer !== null)
                        .sort((left, right) => left.label.localeCompare(right.label, 'it', { sensitivity: 'base' }));
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                    this.formError = 'Non è stato possibile caricare l\'elenco clienti.';
                }
            });

        this.referrerService.getAll()
            .subscribe({
                next: (referrers: Array<Referrer>) => {
                    this.loadedReferrers = referrers;
                    this.publishPartyOptions();
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                    this.loadedReferrers = [];
                    this.partyLoadError = 'Non è stato possibile caricare i segnalatori.';
                    this.publishPartyOptions();
                }
            });

        this.supplierService.getAll()
            .subscribe({
                next: (suppliers: Array<Supplier>) => {
                    this.loadedSuppliers = suppliers;
                    this.publishPartyOptions();
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                    this.loadedSuppliers = [];
                    this.partyLoadError = this.partyLoadError || 'Non è stato possibile caricare i fornitori.';
                    this.publishPartyOptions();
                }
            });

        this.requestInvestmentRanges = [
            {
                "IDInvestmentRange": 0,
                "InvestmentRangeLabel": "Da euro 0 a euro 100.000"
            },
            {
                "IDInvestmentRange": 1,
                "InvestmentRangeLabel": "Da euro 100.000 a euro 300.000"
            },
            {
                "IDInvestmentRange": 2,
                "InvestmentRangeLabel": "Da euro 300.000 a euro 500.000"
            },
            {
                "IDInvestmentRange": 3,
                "InvestmentRangeLabel": "Superiore a euro 500.000"
            },
            {
                "IDInvestmentRange": 4,
                "InvestmentRangeLabel": "Personalizzato"
            }
        ];
        this.selectedInvestmentRangeId = this.requestInvestmentRanges[this.requestInvestmentRanges.length - 1].IDInvestmentRange;
    }

    onRequestTypeChange(): void {
        const requestType = Number(this.request.FKIDRequestType);
        this.selectedInvestmentRangeId = 4;
        this.request.PaymentCost1 = 0;
        this.request.PaymentCost2 = 0;
    }

    onRequestInvestmentRangeChange(investmentRangeId: number): void {
        switch (this.request.FKIDRequestType) {
            case 6:
                switch (this.selectedInvestmentRangeId) {
                    case 0:
                        this.request.PaymentCostExpertise = 1200;
                        this.request.PaymentCostCertification = 250;
                        this.request.PaymentCost1 = 800;
                        this.request.PaymentCost2 = 1250;
                        break;

                    case 1:
                        this.request.PaymentCostExpertise = 1500;
                        this.request.PaymentCostCertification = 300;
                        this.request.PaymentCost1 = 900;
                        this.request.PaymentCost2 = 1800;
                        break;

                    case 2:
                        this.request.PaymentCostExpertise = 2500;
                        this.request.PaymentCostCertification = 500;
                        this.request.PaymentCost1 = 1000;
                        this.request.PaymentCost2 = 2000;
                        break;

                    case 3:
                    case 4:
                        this.request.PaymentCostExpertise = 0;
                        this.request.PaymentCostCertification = 0;
                        this.request.PaymentCost1 = 0;
                        this.request.PaymentCost2 = 0;
                        break;
                }
                break;

            case 7:
                switch (this.selectedInvestmentRangeId) {
                    case 0:
                        this.request.PaymentCostExpertise = 1200;
                        this.request.PaymentCostCertification = 250;
                        this.request.PaymentCost2 = 1250;
                        break;

                    case 1:
                        this.request.PaymentCostExpertise = 1500;
                        this.request.PaymentCostCertification = 300;
                        this.request.PaymentCost2 = 1800;
                        break;

                    case 2:
                        this.request.PaymentCostExpertise = 2500;
                        this.request.PaymentCostCertification = 500;
                        this.request.PaymentCost1 = 0;
                        this.request.PaymentCost2 = 2000;
                        break;

                    case 3:
                        this.request.PaymentCostExpertise = 0;
                        this.request.PaymentCostCertification = 0;
                        this.request.PaymentCost1 = 0;
                        this.request.PaymentCost2 = 0;
                        break;

                    case 4:
                        this.request.PaymentCostExpertise = 0;
                        this.request.PaymentCostCertification = 0;
                        this.request.PaymentCost1 = 0;
                        this.request.PaymentCost2 = 0;
                        break;
                }
                break;
        }
    }

    searchCustomer = (term: string, item: CustomerPick): boolean => {
        return item.searchText.indexOf((term || '').trim().toLowerCase()) !== -1;
    };

    searchPartyOption = searchParty;

    private publishPartyOptions(): void {
        this.partyOptions = partyOptionList(this.loadedReferrers || [], this.loadedSuppliers || []);
    }

    get selectedCustomer(): CustomerPick | null {
        if (this.selectedCustomerId == null) {
            return null;
        }
        return this.customerOptions.find(customer => customer.id === this.selectedCustomerId) || null;
    }

    onCustomerChange(customerId: number | null): void {
        this.formError = '';
        this.recipientSelection = {};
        const customer = this.customerOptions.find(option => option.id === customerId);
        if (!customer) {
            return;
        }
        customer.emails.forEach(email => {
            this.recipientSelection[email] = true;
        });
    }

    trackByEmail(_index: number, email: string): string {
        return email;
    }

    isRecipientSelected(email: string): boolean {
        return !!this.recipientSelection[email];
    }

    toggleRecipient(email: string, event: Event): void {
        this.recipientSelection[email] = (event.target as HTMLInputElement).checked;
    }

    private selectedRecipientEmails(): string[] {
        const customer = this.selectedCustomer;
        if (!customer) {
            return [];
        }
        return customer.emails.filter(email => this.recipientSelection[email]);
    }

    createRequest() {
        if (this.saving) {
            return;
        }
        const customer = this.selectedCustomer;
        let recipientEmails: string[] = [];
        if (customer) {
            recipientEmails = this.selectedRecipientEmails();
            if (recipientEmails.length === 0) {
                this.formError = customer.emails.length === 0
                    ? 'Questo cliente non ha email. Annulla la selezione oppure aggiungi un\'email dalla sua anagrafica.'
                    : 'Seleziona almeno un\'email del cliente.';
                return;
            }
        } else {
            const parsed = normalizeCustomerEmails(this.newCustomerEmails);
            if (parsed.error) {
                this.formError = parsed.error;
                return;
            }
            recipientEmails = parsed.emails;
        }

        this.formError = '';
        this.saving = true;
        const parties = splitPartyKeys(this.selectedPartyKeys);
        const payload: Request = Object.assign(new Request(), this.request, {
            FKIDCustomer: customer ? customer.id : null,
            InternalManagement: !!this.request.InternalManagement,
            Email: recipientEmails[0],
            EmailSecondary: '',
            recipientEmails,
            ReferrerIDs: parties.referrerIds,
            SupplierIDs: parties.supplierIds
        });

        this.userSessionService.create()
            .subscribe({
                next: (userSessionCreated: UserSession) => {
                    payload.FKIDUserSession = userSessionCreated.IDUserSession;
                    payload.ProgressStatus = 0;
                    payload.Simplified = false;
                    this.requestService.create(payload)
                        .subscribe({
                            next: (requestCreated: Request) => {
                                this.saving = false;
                                this.activeModal.close(requestCreated);
                            },
                            error: (err: HttpErrorResponse) => {
                                this.saving = false;
                                this.formError = err.error?.err || 'Non è stato possibile creare la pratica.';
                                console.log(err);
                            }
                        });
                },
                error: (err: HttpErrorResponse) => {
                    this.saving = false;
                    this.formError = 'Non è stato possibile creare la pratica.';
                    console.log(err);
                }
            });
    }

}
